import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store'
import {trackPageView} from "@/services/analytics";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    },
    {
        path: '/admin',
        name: 'AdminView',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminView.vue'),
        meta: {
            requiresAdmin: true
        }
    },
    {
        path: '/preisrechner',
        name: 'PreisrechnerView',
        component: () => import(/* webpackChunkName: "preisrechner" */ '@/views/Preisrechner.vue')
    },
    {
        path: '/companyregister',
        name: 'CompanyRegisterView',
        component: () => import(/* webpackChunkName: "preisrechner" */ '@/views/CompanyRegisterView.vue')
    },
    {
        path: '/verify',
        name: 'VerifyView',
        component: () => import('@/views/VerifyView.vue')
    },
    {
        path: '/company',
        name: 'companySiteView',
        component: () => import(/* webpackChunkName: "company" */ '@/views/companySiteView.vue')
    },
    {
        path: '/comp/:slug',
        redirect: to => `/${to.params.slug}`
    },
    {
        path: '/info',
        name: 'Info',
        component: () => import(/* webpackChunkName: "account" */ '@/views/InfoView')
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: () => import(/* webpackChunkName: "legal" */ '@/views/LegalView.vue'),
        props: {page: 'faq'}
    },
    {
        path: '/impressum',
        name: 'Impressum',
        component: () => import(/* webpackChunkName: "legal" */ '@/views/LegalView.vue'),
        props: {page: 'imprint'}
    },
    {
        path: '/datenschutz',
        name: 'Datenschutz',
        component: () => import(/* webpackChunkName: "legal" */ '@/views/LegalView.vue'),
        props: {page: 'privacy'}
    },
    {
        path: '/anfragen',
        name: 'AnfragenView',
        component: () => import(/* webpackChunkName: "companyRequests" */ '@/views/AnfragenView.vue')
    },
    {
        path: '/:slug/impressum',
        name: 'CompanyImpressum',
        component: () => import(/* webpackChunkName: "companyPublic" */ '@/views/CompanyLegalView.vue'),
        props: {page: 'impressum'}
    },
    {
        path: '/:slug/datenschutz',
        name: 'CompanyDatenschutz',
        component: () => import(/* webpackChunkName: "companyPublic" */ '@/views/CompanyLegalView.vue'),
        props: {page: 'datenschutz'}
    },
    {
        path: '/:slug/agb',
        name: 'CompanyAGB',
        component: () => import(/* webpackChunkName: "companyPublic" */ '@/views/CompanyLegalView.vue'),
        props: {page: 'agb'}
    },
    {
        path: '/:slug',
        name: 'CompanyPublicView',
        component: () => import(/* webpackChunkName: "companyPublic" */ '@/views/CompanyPublicView.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    if (!to.meta.requiresAdmin) {
        next()
        return
    }

    const token = store.getters.jwt || localStorage.getItem('jwt')

    if (!store.getters.user && token) {
        await store.dispatch('login', {jwt: token})
    }

    if (store.getters.user?.isAdmin === true) {
        next()
        return
    }

    next('/')
})

const trackedWebsiteRoutes = {
    Home: 'Startseite',
    PreisrechnerView: 'Preisrechner',
    FAQ: 'FAQ',
    Impressum: 'Impressum',
    Datenschutz: 'Datenschutz',
    CompanyRegisterView: 'Unternehmen eintragen'
}

router.afterEach((to) => {
    const title = trackedWebsiteRoutes[to.name]

    if (!title) {
        return
    }

    trackPageView({
        pageType: 'website',
        path: to.path,
        companyName: title
    }).catch(() => null)
})

export default router
